import SEOHead from '@/components/SEOHead';
import DemoHeroV2 from '@/components/marketing/demo/DemoHeroV2';
import DemoVideosSectionV2 from '@/components/marketing/demo/DemoVideosSectionV2';
import DemoStepsSectionV2 from '@/components/marketing/demo/DemoStepsSectionV2';
import DemoFormSectionV2 from '@/components/marketing/demo/DemoFormSectionV2';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';

export default function Demo() {
  return (
    <>
      <SEOHead
        title="Démo Velko POS — Voyez la caisse en 10 minutes"
        description="Réservez une démo live de Velko POS (WhatsApp ou visio, 20-30 min) ou regardez nos vidéos de démonstration module par module : vente, hors-ligne, crédit, stock, rapports."
        path="/demo"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Démo', path: '/demo' },
        ]}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'Comment se passe une démo Velko ?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: "Vous nous écrivez sur WhatsApp ou via le formulaire, on planifie un appel live de 20 à 30 minutes sur un compte réel, puis vous démarrez un essai gratuit de 14 jours accompagné.",
              },
            },
            {
              '@type': 'Question',
              name: 'La démo est-elle gratuite et sans engagement ?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Oui, la démo et les 14 premiers jours sont gratuits, sans carte bancaire requise.',
              },
            },
          ],
        }}
      />

      <DemoHeroV2 />
      <DemoVideosSectionV2 />
      <DemoStepsSectionV2 />
      <DemoFormSectionV2 />
      <FinalCtaSection
        eyebrow="Prêt à tester ?"
        title="Essaie Velko gratuitement."
        highlight="Sans carte."
        subtitle="Crée ton compte en 3 minutes, importe ton catalogue, fais ta première vente. Si quelque chose coince, on est là."
        primaryLabel="Créer un compte gratuit"
        primaryTo="/register"
        secondaryLabel="Voir les tarifs"
        secondaryTo="/tarifs"
      />
    </>
  );
}
